import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditCashReceived = () => {
    const { id } = useParams(); // Get the id from the URL params
    const [staffId, setStaffId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch current cash received data
        fetch(`${BASE_URL}cashpayment/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const { staff_id, c_id, amount, description } = data.data;
                    setStaffId(staff_id);
                    setCustomerId(c_id);
                    setAmount(amount);
                    setDescription(description);
                } else {
                    alert('Failed to fetch data.');
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        if (!staffId || !customerId || !amount || !description) {
            alert("Please provide all required fields!");
            return;
        }

        const formData = new FormData();
        formData.append('staff_id', staffId);
        formData.append('c_id', customerId);
        formData.append('amount', amount);
        formData.append('description', description);

        fetch(`${BASE_URL}cashpayment/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert("Cash received entry updated successfully!");
                    navigate('/CashReceivedList'); // Redirect to the list page
                } else {
                    alert("Error updating cash received entry. Please try again.");
                }
            })
            .catch(error => console.error('Error updating cash received entry:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Cash Received</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Cash Received Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Cash Received Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="staffId" className="form-label">Staff ID</label>
                                        <input
                                            type="number"
                                            id="staffId"
                                            className="form-control"
                                            value={staffId}
                                            onChange={(e) => setStaffId(e.target.value)}
                                            placeholder="Enter staff ID"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customerId" className="form-label">Customer ID</label>
                                        <input
                                            type="number"
                                            id="customerId"
                                            className="form-control"
                                            value={customerId}
                                            onChange={(e) => setCustomerId(e.target.value)}
                                            placeholder="Enter customer ID"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            placeholder="Enter amount"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Enter description"
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Cash Received</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Cash Received Form */}
        </div>
    );
};

export default EditCashReceived;
